/**
 * Extract plain text from a CMS-supplied HTML string. Strips tags and decodes
 * the most common HTML entities — intended for non-display contexts such as
 * `aria-label`, document title, or plain-text alt text.
 *
 * Isomorphic: works in both Server and Client Components.
 *
 */
const ENTITY_MAP: Record<string, string> = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&apos;': "'",
    '&nbsp;': ' ',
};

export function stripHtml(input: string): string {
    return input
        .replace(/<[^>]*>/g, '') // strips HTML tags
        .replace(/&(?:amp|lt|gt|quot|#39|apos|nbsp);/g, (m) => ENTITY_MAP[m] ?? m) // swaps named entities; i.e. &amp; -> &
        .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(Number(code))) // swaps numeric entities; i.e. &#8230; → …
        .replace(/\s+/g, ' ') // collapses any whitespace to a single space
        .trim();
}
